export const manifest = {
  screens: {
    scr_4hiihr: { name: "All You Need Is Love", route: "/", state: {"slide":0}, position: {"x":39360,"y":220} },
    scr_b2ks1n: { name: "HCPs Don’t Lack Content. They Lack Time.", route: "/", state: {"slide":1}, position: {"x":29560,"y":220} },
    scr_5efz5w: { name: "What Can Be Snakified?", route: "/", state: {"slide":2}, position: {"x":47760,"y":220} },
    scr_fl630q: { name: "Boehringer Is Already Snakifying", route: "/", state: {"slide":3}, position: {"x":49160,"y":220} },
    scr_qclpfx: { name: "From Individual Snaks to Shared Advantage", route: "/", state: {"slide":4}, position: {"x":50560,"y":220} },
    scr_7yzgqg: { name: "From Snak to Campaign", route: "/", state: {"slide":5}, position: {"x":42160,"y":220} },
    scr_aqx7nl: { name: "One Experience, Many Channels", route: "/", state: {"slide":6}, position: {"x":2960,"y":220} },
    scr_6h2q2t: { name: "What Could We Snakify for Your Brand?", route: "/", state: {"slide":7}, position: {"x":160,"y":2200} },
  },
  sections: {
    sec_cmsdzd: { name: "Business Proposal Flow", x: 0, y: 0, width: 51920, height: 1180 },
    sec_zf5ksd: { name: "Implementation & Execution", x: 0, y: 1980, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_cmsdzd", children: [
      { kind: "screen", id: "scr_aqx7nl" },
      { kind: "screen", id: "scr_b2ks1n" },
      { kind: "screen", id: "scr_4hiihr" },
      { kind: "screen", id: "scr_7yzgqg" },
      { kind: "screen", id: "scr_5efz5w" },
      { kind: "screen", id: "scr_fl630q" },
      { kind: "screen", id: "scr_qclpfx" },
    ] },
    { kind: "section", id: "sec_zf5ksd", children: [
      { kind: "screen", id: "scr_6h2q2t" },
    ] },
  ],
}
